import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import { geoFromIP } from 'utils/bolt/geo';
import * as BaseComp from 'components/bolt/footer/footer.js';
import s from 'components/bolt/footer/footer.sss';

// including US and CA  as they need the cookies modal too
const gdprRegions = ['at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se', 'gb', 'us', 'ca'];

class StaticButton extends Component {
	shouldComponentUpdate() {
		return false;
	}
	render(props) {
		return <button type="button" {...props} />;
	}
}

export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		const geo = await geoFromIP();
		if (gdprRegions.includes(geo?.countryCode)) {
			this.setState({ gdprRegion: true });
		}
	}

	renderLinks(items, type) {
		const base = super.renderLinks(items, type);
		const usingOneTrust = accessNested(this.props, 'store.appData.options.oneTrustCookieConsent.scripts');
		const usingKetch = accessNested(this.props, 'store.appData.options.ketchCookieConsent.scripts');

		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		const underAge = ageGateEnabled && !isOfAge;

		if (type !== 'link' || (!usingKetch && !usingOneTrust) || underAge || !this.state.gdprRegion) {
			return base;
		}

		if (this.props.store?.appData?.footer?.defaultFooter?.noParamountExtraLink) {
			return base;
		}

		if (usingOneTrust) {
			let cookieLinkText = '';

			if (typeof window !== 'undefined') {
				cookieLinkText = window.OneTrust?.GetDomainData?.()?.AlertMoreInfoText || 'Your Privacy Choices';
			}

			return [].concat(base, (
				<li class={s.linkWrapper} key="onetrust-manage-cookies">
					<StaticButton
						class={joinClasses(s.linkLink, 'ot-sdk-show-settings')}
						role="button"
						onClick={() => window.OneTrust?.ToggleInfoDisplay()}
					>
						{cookieLinkText}
					</StaticButton>
				</li>
			));
		}


		return [].concat(base, (
			<li class={s.linkWrapper} key="ketch-manage-cookies">
				<StaticButton
					class={joinClasses(s.linkLink, 'ot-sdk-show-settings')}
					role="button"
					onClick={() => window.ketch('showPreferences')}
				>
					Your Privacy Choices
				</StaticButton>
			</li>
		));
	}
}
